// eslint-disable-next-line no-restricted-imports -- тут можно т.к. реализация обертки
import { copyTextToClipboard as copyTextToClipboardRoot } from '@direct-frontend/stdlib';
import { showError, showSuccess } from '../../toast';

/*
 * Копирование текста в буфер обмена
 */
export const copyTextToClipboard = async (text?: string) => {
    try {
        if (!text) {
            throw new Error('Нет текста для копирования');
        }

        await copyTextToClipboardRoot(text);

        showSuccess('Скопировано');
    } catch (error) {
        showError({ label: 'Не удалось скопировать текст' }, error);
    }
};
